import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=019b3b8a&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=019b3b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b3b8a",
  null
  
)

export default component.exports